import React from "react";
import { useStoreSettings } from "../../../../../hooks/useStoreSettings";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";
import {
    getVariantDisplayFromDiscount,
    formatDiscountLabel,
    groupDiscountsByType
} from "../../../../../utils/discountUtils";

const DiscountInfo = ({ productDiscounts = [] }) => {
    // Get store settings for currency
    const { currency: storeCurrency } = useStoreSettings();
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    if (!productDiscounts || productDiscounts.length === 0) {
        return <span className="no-discount">{t('noDiscount')}</span>;
    }

    // Group discounts by type
    const { productDiscounts: productLevelDiscounts, variantDiscounts } = groupDiscountsByType(productDiscounts);

    // Single discount case
    if (productDiscounts.length === 1) {
        const discount = productDiscounts[0];
        return (
            <div className="discount-info">
                <span className="discount-label">
                    {formatDiscountLabel(discount, storeCurrency)}
                    {discount.variantId && (
                        <small className="variant-indicator">
                            ({getVariantDisplayFromDiscount(discount)})
                        </small>
                    )}
                </span>
                {discount.endDate && (
                    <span className="discount-expiry">
                        Until {new Date(discount.endDate).toLocaleDateString()}
                    </span>
                )}
            </div>
        );
    }

    // Multiple discounts case
    return (
        <div className="discount-info-enhanced">
            {productLevelDiscounts.length > 0 && (
                <div className="discount-item">
                    <span className="discount-label-main">
                        {formatDiscountLabel(productLevelDiscounts[0], storeCurrency)} (All variants)
                    </span>
                </div>
            )}

            {variantDiscounts.length > 0 && (
                <div className="variant-discounts">
                    <span className="discount-count">
                        {variantDiscounts.length} variant discount{variantDiscounts.length > 1 ? 's' : ''}
                    </span>

                    {/* Show first few variant discounts */}
                    {variantDiscounts.slice(0, 2).map((discount, index) => (
                        <div key={discount.id} className="variant-discount-item">
                            <span className="discount-label-variant">
                                {formatDiscountLabel(discount, storeCurrency)} - {getVariantDisplayFromDiscount(discount)}
                            </span>
                        </div>
                    ))}

                    {variantDiscounts.length > 2 && (
                        <span className="more-discounts">
                            +{variantDiscounts.length - 2} more...
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default DiscountInfo;